export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) {
    const authStore = useAuthStore();
    const { user, isNormalUser } = storeToRefs(authStore);

    if (!user.value || isNormalUser.value) {
      throw createError({
        status: 403,
        message: "ไม่มีสิทธิ์",
      });
    }
  }
});
